import React from 'react';
import { Box, Container, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import TitleBar from '../../components/TitleBar/TitleBar';
import ComputedMetricsContent from './ComputedMetricsContent';
const ViewComputedMetrics = () => {
  const navigate = useNavigate();
  return (
    <>
      <TitleBar title="Computed Metrics" />
      <Container maxWidth="xl">
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, mt: 2 }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            onClick={() => navigate('/view-metrics')}
          >
            Back to View Metrics
          </Button>
        </Box>

        <ComputedMetricsContent />
      </Container>
    </>
  );
};

export default ViewComputedMetrics;